import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';

import AboutCompany1 from '../images/AboutUs/about-company1.jpg';
import AboutCompany2 from '../images/AboutUs/about-company2.jpg';
import AboutCompany3 from '../images/AboutUs/about-company3.jpg';
import AboutCompany4 from '../images/AboutUs/about-company4.jpg';
import { HlzOffice } from '../components/HlzOffice';
import { HlzFactory } from '../components/HlzFactory';
import './AboutUs.css';

import aboutusbg from '../images/PageImg/AboutUs-page-bg.jpg'
import HeaderSlide from '../components/HeaderSlide'
import { GoTopBtn } from '../components/GoTopBtn';

function AboutUs() {
  // console.log("into AboutUs()");
  return (
    <div className='aboutus-page'>
      <div className='aboutusheader'
        style={{ backgroundImage: `url(${aboutusbg})`, height: "auto" }} >
        <HeaderSlide text={'About Us'} />
        <h4 className='text-dark'>&nbsp;&nbsp;images/PageImg/AboutUs-page-bg.jpg</h4>
      </div>
      <Container fluid className='my-5'>
        <h2 className='text-center'>合利资光电十周年庆典</h2>
        <Row>
          <Col lg={6} className='flex-column justify-content-center'>
            <img src={AboutCompany1} className='img-fluid my-0' alt="" />
            <h4>images/AboutUs/about-company1.jpg</h4>
            <img src={AboutCompany2} className='img-fluid my-0' alt="" />
            <h4>images/AboutUs/about-company2.jpg</h4>
          </Col>
          <Col lg={6} className='flex-column justify-content-center'>
            <img src={AboutCompany3} className='img-fluid my-0' alt="" />
            <h4>images/AboutUs/about-company3.jpg</h4>
            <img src={AboutCompany4} className='img-fluid my-' alt="" />
            <h4>images/AboutUs/about-company4.jpg</h4>
          </Col>
        </Row>
      </Container>

      <div className='bg-dark text-light'> <HlzOffice /> </div>
      <div className='bg-dark text-light'> <HlzFactory /> </div>

      <div> < GoTopBtn /> </div>
    </div>
  )
}

export default AboutUs;

/* <br /> <br /> <br /> */
/*
<header className='mt-5'>
  <div className='container h-100 d-flex align-items-center justify-content-center'>
    <h1 className='text-light'>About Us</h1>
  </div>
</header>
*/

/* <img src={AboutCompany1} className='img-fluid my-4' alt="" /> */